import request from "@/plugins/axiosRequest";

const url = "/api/dashboard/v1/dashboard";

export function fetchList(query) {
  return request({
    url: url,
    method: "get",
    params: query
  });
}

export function getAmountAvailable(coin) {
  return request({
    url: `${url}/amount_available`,
    method: "get",
    params: { coin }
  });
}
